module.exports = __webpack_public_path__ + "static/media/quiz-checkmark-light-on@2x.dd256709.png";